export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al proceso"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lotes"])},
          "harvested_batches_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lotes"])},
          "new_harvested_batch_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo lote"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "total_harvested_batches": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Lotes"])}
        }
      }
    }
  })
}